(function(){
    'use strict';
    angular.module('Services').factory('HistoricalChatsTableService', HistoricalChatsTableService);
    HistoricalChatsTableService.$inject = [
        'FleetService',
        'TableLiteFactory',
        'toastr'
    ];
    
    function HistoricalChatsTableService(
        FleetService,
        TableLiteFactory,
        toastr
    ) {
        return function(params) {
            let tableData = {
                tableName: 'HistoricalChatsTable',
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTopOptions: true,
                    noTableFooter: false,
                },
                headers: [
                    {
                        width: '10%',
                        label: 'Sender',
                        viewName: 'sender'
                    },
                    {
                        label: 'Messages',
                        viewName: 'message'
                    }
                ],
                data: [],
                onInit: function(){
                    tableActions.sendRequest();
                }
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: FleetService.Chat.chatHistory,
                callbackFormat: ['id', 'success', 'error', 'filter'],
                paramId: params.jobId,
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    toastr.error(err);
                },
                defaultFilters: {
                    size: 10,
                    page: 0,
                    sort: 'id,asc'
                }
            });

            function buildTableData(data){
                if(data.content.length != 0) {
                    tableActions.initializeTableData(data);
                    angular.forEach(data.content, function(item){
                        item.sender = item.sender;
                        item.message = item.message;
                        tableData.data.push(item);
                    });
                }
            }
            this.tableData = tableData;
        }   
    }
})()


// WEBPACK FOOTER //
// ./js/services/tables/HistoricalChatsTableService.js